if(document.getElementsByClassName('GrowerPage').length > 0) {

    document.addEventListener("DOMContentLoaded", function () {
        const applyGrowerButtonAbove = document.querySelector("#apply-grower-btn-above");
        const applyGrowerButtonBelow = document.querySelector("#apply-grower-btn-below");
        const applyGrowerButtonHeader = document.querySelector("#btn-apply");
        const applyGrowerButtonSticky = document.querySelector("#btn-apply-sticky");
        const btnApplyNow = document.querySelectorAll(".btn-apply-now");

        function scrollToElement(element, offset) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }

        btnApplyNow?.forEach(button => {
            button.addEventListener("click", () => {
                const applyFormTitle = document.querySelector("#grower-application");
                const offset = 130;
                scrollToElement(applyFormTitle, offset);
            });
        });

    });

    const newFarmerButton = document.querySelector("#btn-new-farmer");
    newFarmerButton?.addEventListener("click", event => {
        const newFarmerContainer = document.querySelector("#new-farmer-form-container");
        const existingFarmerContainer = document.querySelector("#existing-farmer-form-container");
        newFarmerContainer.style.display = "block";
        existingFarmerContainer.style.display = "none";
        return false;
    });
    const existingFarmerButton = document.querySelector("#btn-existing-farmer");
    existingFarmerButton?.addEventListener("click", event => {
        const newFarmerContainer = document.querySelector("#new-farmer-form-container");
        const existingFarmerContainer = document.querySelector("#existing-farmer-form-container");
        newFarmerContainer.style.display = "none";
        existingFarmerContainer.style.display = "block";
        return false;
    });

    // let farmerRequirements = document.querySelectorAll(".farmer-requirement");
    // farmerRequirements?.forEach(requirement => {
    //     requirement.addEventListener("change", event => {
    //         let allChecked = Array.from(farmerRequirements).every(requirement => requirement.checked);
    //         if (allChecked) {
    //             document.querySelector("#new-farmer-form").classList.remove("hide");
    //         } else {
    //             document.querySelector("#new-farmer-form").classList.add("hide");
    //         }
    //         // document.querySelector("#existing-farmer-form").classList.add("hide");
    //     });
    // });

    const newFarmerRequirements = document.querySelector("#requirements-agreement");
    newFarmerRequirements?.addEventListener("change", event => {
        if (event.target.checked) {
            document.querySelector("#new-farmer-form").classList.remove("hide");
        } else {
            document.querySelector("#new-farmer-form").classList.add("hide");
        }
    });

            
    // document.querySelector("#option-existing-farmer")?.addEventListener("change", event => {
    //     if (event.target.checked) {
    //         document.querySelector("#new-farmer-form").classList.add("hide");
    //         document.querySelector("#existing-farmer-form").classList.remove("hide");
    //     } else {
    //         document.querySelector("#existing-farmer-form").classList.add("hide");
    //         let farmerRequirements = document.querySelectorAll(".farmer-requirement");
    //         // if all farmer requirements are checked, show the new farmer form
    //         let allChecked = Array.from(farmerRequirements).every(requirement => requirement.checked);
    //         if (allChecked) {
    //             document.querySelector("#new-farmer-form").classList.remove("hide");
    //         }
    //     }
    // });


	const applicationForms = document.querySelectorAll(".farmer-inquiry-form");

    applicationForms?.forEach(applicationForm => {

        applicationForm?.querySelector("select[name=location-state]")?.addEventListener("change", event => {
            let city = document.querySelector("[name=location-city]");
            document.querySelector("[name=location-none]")?.classList.toggle("hidden", event.target.value !== "none");
            city.classList.toggle("hidden", event.target.value === "none");
            city.required = event.target.value !== "none";
        });
        
        applicationForm?.querySelector("select[name=has-experience]")?.addEventListener("change", event => {
            let experience = document.querySelector("[name=experience]");
            
            experience.classList.toggle("hidden", event.target.value === "no");
            experience.required = event.target.value === "yes";
        });

        applicationForm?.querySelector("select[name=has-acreage]")?.addEventListener("change", event => {
            let experience = document.querySelector("[name=address]");
            
            experience.classList.toggle("hidden", event.target.value === "no");
            experience.required = event.target.value === "yes";
        });

        applicationForm?.querySelector("input[name=acreage-information]")?.addEventListener("blur", event => {     
            let acreage = event.target.value;
            let acreageMessage = document.querySelector(".acreage-message");
            if(acreage < 10) {
                acreageMessage.style.display = "block";
            } else {
                acreageMessage.style.display = "none";
            }
            
        });

        applicationForm?.addEventListener("submit", event => {
            event.preventDefault();
            event.stopPropagation();
    
            const formData = new FormData(event.target);
    
            applicationForm.classList.add("locked");
    
            fetch(applicationForm.action, {
                method: "POST",
                body: formData
            })
            .then(response => response.json())
            .then((payload) => {
                if (payload.success) {
                    // applicationForm.classList.add("success");
                    // applicationForm.querySelector(".success-message").textContent = payload.message;
                    const formContainer = applicationForm.closest(".farmer-form-container");
                    applicationForm.style.display = "none";
                    formContainer.querySelector(".form-wrap").style.display = "none";
                    formContainer.querySelector(".success").style.display = "block";
                    // Scroll to the top of the form container
                    const offset = 130;
                    const topPosition = formContainer.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({
                        top: topPosition,
                        behavior: "smooth"
                    });
                }
                else {
                    applicationForm.classList.remove("locked");
                    applicationForm.classList.add("error");
                    applicationForm.querySelector(".error-message").textContent = payload.message;
                }
            });
    
            return false;
        });
    

    });

    const notEligible = document.querySelector("#not-eligible");
    notEligible?.addEventListener("change", () => {
        const notEligibleModal = document.querySelector("#not-eligible-modal");
        if (notEligible.checked) {
            let modal = bootstrap.Modal.getInstance(notEligibleModal);
            if (!modal) {
                modal = new bootstrap.Modal(notEligibleModal);
            }
            modal.show();
        }
    });

    const fundingDropdown = document.querySelector("#funding-dropdown");
    fundingDropdown?.addEventListener("change", event => {
        const selectedValue = event.target.value;
        const fundingInfo = document.querySelector("#funding-information");

        if (selectedValue == "1") {
            fundingInfo.style.display = "block";
            fundingInfo.querySelector("textarea").required = true;
        } else {
            fundingInfo.style.display = "none";
            fundingInfo.querySelector("textarea").required = false;
        }
    });


    // document.getElementById('apply-submit-btn')?.addEventListener('click', function() {
    //     let checkboxes = document.querySelectorAll('input.referral:checked');

    //     if(checkboxes.length == 0) {
    //         applicationForm.querySelector(".referral-error-message").classList.add('show');
    //         applicationForm.classList.add("error");
    //         return false;
    //     } else {
    //         applicationForm.classList.remove("error");
    //         applicationForm.querySelector(".referral-error-message").classList.remove('show');
    //     }
        
    // });


    const preApproveCheckbox = document.querySelector("#pre-approve");
    preApproveCheckbox?.addEventListener("change", event => {
        if (event.target.checked) {
            document.querySelector("#apply-now-form").classList.remove("hide");
        } else {
            document.querySelector("#apply-now-form").classList.add("hide");
        }
    });

    // const hasAcreage = document.querySelector("#has-acreage");
    // hasAcreage?.addEventListener("change", event => {
    //     if (event.target.value === "1") {
    //         document.querySelector("#farm-address-wrap").classList.remove("hide");
    //         document.querySelector("#secure-loan-wrap").classList.add("hide");
    //     } else if (event.target.value === "0") {
    //         document.querySelector("#secure-loan-wrap").classList.remove("hide");
    //     } else {
    //         document.querySelector("#farm-address-wrap").classList.add("hide");
    //     }
    // });


}